import React from "react";
import { useState, useEffect } from "react";
import styled from "styled-components";
import { Container, Row, Col } from "react-bootstrap";
import { SliderProcess } from "./sliderProcess";
import { SliderOfferAdvantages } from "./sliderOfferAdvantages";
import { useTranslation } from "react-i18next";
import { SliderDoctors } from "./sliderDoctors";
import { SliderVentajas } from "./sliderVentajas";
const WhiteSection = styled.div`
  width: 100%;
  height: auto;
  background-color: #fff;
  h2 {
    font-family: "IBM Plex Sans";
    font-weight: 700;
    font-size: 24px;
    line-height: 31px;
    text-align: center;
    color: #1c3245;
    margin-bottom: 64px;
    @media only screen and (max-width: 768px) {
      font-size: 17px;
      line-height: 26px;
      padding-left: 22px;
      text-align: left;
      margin-bottom: 45px;
    }
  }
  #sliders-div {
    margin-bottom: 80px;
  }
`;

const Title = styled.h1`
  font-family: IBM Plex Sans;
  font-weight: 700;
  font-size: 40px;
  line-height: 52px;
  text-align: center;
  color: #eaac34;
  margin-bottom: 35px;
  @media only screen and (max-width: 768px) {
    font-size: 30px;
    line-height: 39px;
    padding-left: 22px;
    padding-right: 22px;
    padding-top: 12px;
    margin-bottom: 25px;
  }
`;

const Process = styled(Col)`
  text-align: left;
  a {
    text-decoration: underline;
    color: #353433;
  }
  li {
    font-weight: 400;
    font-size: 17px;
    line-height: 24px;
    color: #353433;
  }
  span {
    font-weight: 700;
  }
  h1 {
    font-size: 30px;
    line-height: 39px;
    margin-bottom: 22px;
    @media only screen and (max-width: 768px) {
      font-size: 24px;
      line-height: 31px;
      padding-left: 12px;
    }
  }
`;

const YellowDiv = styled.div`
  background: #ffffff;
  border: 2px solid #eaac34;
  border-radius: 40px;
  overflow: hidden;
  width: 100%;
  max-width: 544px;
  margin: 0 auto;
  h1 {
    background: #eaac34;
    font-weight: 700;
    font-size: 30px;
    line-height: 130%;
    align-items: center;
    text-align: center;
    letter-spacing: -0.02em;
    color: #ffffff;
    @media only screen and (max-width: 768px) {
      padding-top: 8px;
      padding-bottom: 8px;
    }
  }
`;

const BlueDiv = styled.div`
  background: #ffffff;
  border: 2px solid #1379bc;
  border-radius: 40px;
  overflow: hidden;
  width: 100%;
  margin: 0 auto;
  max-width: 544px;
  @media only screen and (max-width: 992px) {
    margin-top: 31px;
  }
  h1 {
    background: #1379bc;
    font-weight: 700;
    font-size: 30px;
    line-height: 130%;
    align-items: center;
    text-align: center;
    letter-spacing: -0.02em;
    color: #ffffff;
    @media only screen and (max-width: 768px) {
      padding-top: 8px;
      padding-bottom: 8px;
    }
  }
`;

const MainDiv = styled.div`
  background: #FFFFFF;
  font;
  h1 {
    font-weight: 700;
    text-align: center;
    color: #EAAC34;
    font-size: 40px;
    line-height: 130%;
    max-width: 446px;
    @media only screen and (max-width: 768px) {
      font-size: 30px;
    }
  }
  span {
    font-weight: 700;
  }
  #recursos-right {
    @media only screen and (max-width: 768px) {
      display: none;
    }
    background: #F2F7F7;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 40px;
    overflow: hidden;
    width: 90%;
    max-width: 472px;
    margin: 0 auto;
    padding-bottom: 15px;
    p {
      background-color: #EAAC34;
      font-weight: 700;
      font-size: 24px;
      line-height: 31px;
      text-align: center;
      color: #FFFFFF;
      padding-top: 11px;
      padding-bottom: 7px;
    }
    li {
      text-align: left;
      a {
        text-decoration: underline;
        color: #353433;
      }
    }
    #ver-mas {
      font-weight: 400;
      font-size: 17px;
      line-height: 26px;
      text-decoration-line: underline;
      color: #EAAC34;
    }
  }
`;

const GrayDiv = styled.div`
  @media only screen and (max-width: 768px) {
    padding: 30px 36px;
  }
  p {
    font-family: "IBM Plex Sans";
    font-weight: 700;
    font-size: 24px;
    line-height: 31px;
    text-align: center;
    color: #1c3245;
    max-width: 928px;
    margin: 0px auto;
    @media only screen and (max-width: 768px) {
      text-align: left;
      font-size: 17px;
      line-height: 26px;
    }
  }
`;

export const WhyAxiona = () => {
  const { t, i18n } = useTranslation("global");
  const [isMobile, setIsMobile] = useState(false);

  const imageUrl = i18n.language === "en"
    ? "https://firebasestorage.googleapis.com/v0/b/covid19-cc1fe.appspot.com/o/axiona%2Fmedicos%2FH%20S4.png?alt=media&token=d8341770-9a65-4b2d-8436-e56f29f5b019"
    : "https://firebasestorage.googleapis.com/v0/b/covid19-cc1fe.appspot.com/o/axiona%2FaxionaHome%2Fimg%2FH%20S4.png?alt=media&token=6b17ec12-528d-4fa6-9628-6007a3ec9a3f";

      const imageUrl1 = i18n.language === "en"
    ? "https://firebasestorage.googleapis.com/v0/b/covid19-cc1fe.appspot.com/o/axiona%2FaxionaHome%2Fimg%2Fseccioningles.png?alt=media&token=50b4c25c-e2e1-4a0e-a5e8-9c14c2178096"
    : "https://firebasestorage.googleapis.com/v0/b/covid19-cc1fe.appspot.com/o/axiona%2FaxionaHome%2Fimg%2Fseccionespan%CC%83ol.png?alt=media&token=589d95a5-6273-4444-b507-99693baf474c";

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 1024); // puedes ajustar 1024 para lo que consideres "tableta"
    };

    checkScreenSize(); // run on mount

    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  return (
    <>
      <WhiteSection>
        <Container>
          <Title>{t("doctors.why-axiona.title")}</Title>
          <h2>{t("doctors.why-axiona.subtitle")}</h2>
        </Container>
      </WhiteSection>

      <WhiteSection>
        <MainDiv>
          <GrayDiv>
            {isMobile ? (
              <SliderDoctors />
            ) : (
              <img
                alt="slider"
                src={imageUrl}
                style={{ width: "100%", marginBottom: "40px" }}
              />
            )}
          </GrayDiv>
        </MainDiv>
        <MainDiv>
          <GrayDiv>
            {isMobile ? (
              <SliderVentajas/>
            ) : (
              <img
                alt="slider"
                src={imageUrl1}
                style={{ width: "100%", marginBottom: "40px" }}
              />
            )}
          </GrayDiv>
        </MainDiv>
        <Container>
          {/*<Row id="sliders-div">
            <Col md={12} lg={6} data-aos="fade-up">
              <YellowDiv>
                <h1>{t("doctors.why-axiona.slides-offer.title")}</h1>
                <SliderOfferAdvantages cat={0} />
              </YellowDiv>
            </Col>
            <Col md={12} lg={6} data-aos="fade-up">
              <BlueDiv>
                <h1>{t("doctors.why-axiona.slides-advan.title")}</h1>
                <SliderOfferAdvantages cat={1} />
              </BlueDiv>
            </Col>
          </Row>*/}
          <Row>
            <Process xs={12} lg={5}>
              <h1>
                <span>{t("doctors.why-axiona.process.title")} <br />
                {t("doctors.why-axiona.process.title-bold")}
                </span>
              </h1>
              {/*<ol>
                <li>
                  {t("doctors.why-axiona.process.list.1.request")}{" "}
                  <a href="#">{t("doctors.why-axiona.process.list.1.link1")}</a>{" "}
                  {t("doctors.why-axiona.process.list.1.or")}{" "}
                  <a href="#">{t("doctors.why-axiona.process.list.1.link2")}</a>
                  {t("doctors.why-axiona.process.list.1.call")}
                  <span>{t("doctors.why-axiona.process.list.1.bold")}</span>
                </li>
                <li>{t("doctors.why-axiona.process.list.2.desc")}</li>
                <li>{t("doctors.why-axiona.process.list.3.desc")}</li>
                <li>{t("doctors.why-axiona.process.list.4.desc")}</li>
                <li>{t("doctors.why-axiona.process.list.5.desc")}</li>
              </ol>*/}
            </Process>
            <Col xs={12} lg={12}>
              <SliderProcess />
            </Col>
          </Row>
        </Container>
      </WhiteSection>
    </>
  );
};
